module.exports = __webpack_public_path__ + "static/6-720039b4c6c42ef9fc00ff1fcd3acd8d.jpg";